import get from "lodash/get";
import { DESKTOP, MOBILE, PHONE } from "utils/constants/ui";
const FIXED_CLASS = "fixed";

export const getWindow = (path) => {
  if (typeof window !== "undefined") {
    return get(window, path);
  }

  return {};
};

export const isSm = () => {
  return getWindow("innerWidth") <= PHONE;
};

export const isMobile = () => {
  return getWindow("innerWidth") < DESKTOP;
};

export const isPhone = () => {
  return getWindow("innerWidth") < MOBILE;
};

export const formFactorAction = () =>
  getWindow("innerWidth") <= 480 ? "Tap" : "Click";

/**
 * gridCellWidth
 * - Calculate the width of cells within product feeds
 * @param {bool} isMobile
 * @param {bool} isPhone
 * @param {number} columns
 */
export const gridCellWidth = (isMobile, isPhone, columns = 4) => {
  return isMobile
    ? isPhone
      ? "calc(100%)"
      : "calc(33% - 0.5rem)"
    : `calc(${100 / columns}% - 0.5rem)`;
};

export const scrollTop = (node) => {
  if (node && node.scrollIntoView) {
    node.scrollIntoView();
  }
};

export const scrollTo = (x = 0, y = 0) => {
  typeof window !== "undefined" && window.scrollTo(x, y);
};

export const isServer = () => typeof window === "undefined";

export const fixBody = () =>
  document.getElementsByTagName("body")[0].classList.add(FIXED_CLASS);

export const unfixBody = () =>
  document.getElementsByTagName("body")[0].classList.remove(FIXED_CLASS);
